export default "# Warning\n\nIt looks like some **destination prefixes** are not configured, please contact the administrator\n";